import { LitElement, css, html } from 'lit';
import { customElement, property, state } from 'lit/decorators';

import { ifDefined } from 'lit/directives/if-defined';

@customElement('form-input-button')
export class FormInputButton extends LitElement {
    @property({ type: String })
    value: string = '';

    @property({ type: String })
    type?: string;

    @property({ type: String })
    label: string = '';

    @property({ type: String })
    placeholder: string = '';

    @property({ type: String })
    readonly?: string = 'readonly';

    @property({ type: String })
    buttonBackgroundColor?: string;

    @property({ type: String })
    buttonTextColor?: string;

    @state()
    valid: boolean = true;

    private handleChange(e: Event) {
        this.value = (e.target as HTMLInputElement).value;
    }

    private handleClick(e: Event) {
        this.dispatchEvent(
            new CustomEvent('submit', {
                detail: e.target,
            })
        );
    }

    private handleKeyDown(e: KeyboardEvent) {
        if (e.key === 'Enter') {
            const value = (e.target as HTMLInputElement).value;
            this.value = value;
            this.dispatchEvent(
                new CustomEvent('submit', {
                    detail: e.target,
                })
            );
        }
    }

    render() {
        return html`
            ${this.label !== '' ? html` <div class="inputLabel">${this.label}</div> ` : ''}
            <div class="inputArea">
                ${this.readonly === 'readonly'
                    ? html`
                          <input
                              id="textbox"
                              value="${this.value}"
                              placeholder="${this.placeholder}"
                              readonly
                          />
                      `
                    : html` <input
                          id="textbox"
                          class="input-write"
                          value="${this.value}"
                          type="${ifDefined(this.type)}"
                          placeholder="${this.placeholder}"
                          @keydown="${this.handleKeyDown}"
                          @change="${this.handleChange}"
                      />`}
                <form-button
                    class="form-btn"
                    borderStyle="side"
                    .backgroundColor="${this.buttonBackgroundColor}"
                    .textColor="${this.buttonTextColor}"
                    ?fullwidth="${true}"
                    ?fullHeight="${true}"
                    @click="${this.handleClick}"
                >
                    <slot></slot>
                </form-button>
            </div>
        `;
    }

    static get styles() {
        return css`
            .inputArea {
                display: flex;
            }

            .inputLabel {
                font-size: 0.8rem;
                color: var(--main-primary-color);
                margin-bottom: 0.5rem;
            }

            #textbox {
                flex: 1;
                overflow: auto;
                box-sizing: border-box;
                display: block;
                padding: 0.5rem 0.75rem;
                font-size: 0.8rem;
                line-height: 1.5;
                color: var(--theme-lighter-text-color);
                background-color: var(--theme-white-color);
                background-clip: padding-box;
                border: 1px solid var(--theme-input-border-color);
                -webkit-appearance: none;
                -moz-appearance: none;
                appearance: none;
                border-radius: 0.5rem 0 0 0.5rem;
                box-shadow: inset 0 1px 2px transparent;
                transition: background-color 0.15s ease-in-out, border-color 0.15s ease-in-out,
                    box-shadow 0.15s ease-in-out;
                cursor: text;
            }

            #textbox:focus {
                border-color: var(--theme-focus-border-color);
                background-color: var(--theme-white-color);
                outline: 0;
            }

            #textbox.input-write {
                color: var(--theme-input-color);
            }

            .form-btn {
                margin-left: -1px;
            }

            .form-btn:hover {
                opacity: 0.8;
            }
        `;
    }
}
